<template>
  <div>
    <div>
      <el-row class="querybox"
              style="margin-left:920px">
        <el-col :span="17">
          <el-form :model="dataForm">
            <el-select v-model="dataForm.holidayYear"
                       @change="getDataList">
              <el-option v-for="item in year"
                         :key="item"
                         :value="item">{{item}}</el-option>
            </el-select>
          </el-form>
        </el-col>
        <el-col :span="6"
                style="margin-left:3px">
          <el-button size='small'
                     type="primary"
                     v-show="editShow && $hasPermission('CALENDAR002')"
                     @click='edit()'>编辑</el-button>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-form :model="editForm"
               ref="editForm"
               status-icon=status-icon
               :rules="rules">

        <div style="margin-top:10px;margin-left:900px;margin-bottom: 5px; text-align:right">
          <el-button type="primary"
                     v-show="isShow"
                     @click="save('editForm')">保存</el-button>
          <el-button @click="back"
                     v-show="isShow"
                     type="primary">返回</el-button>
        </div>
        <span style="background-color:#A9A9A9;width:100%;height:30px;display:inline-block;text-align:center;line-height:32px; "
              class="calendar-div #calendar">
          公共假期
        </span>
        <!-- <el-table :data="editForm.calendarPublicHolidayDTOList" -->
        <el-table :data="calendarPublicHolidayTableList"
                  ref="tableRef"
                  border
                  stripe
                  v-loading="dataListLoading"
                  :header-cell-class-name="tableHeader"
                  style="width: 100%;">
          <el-table-column prop="publicHolidayName"
                           label="中文名称"
                           header-align="center"
                           align="center">
            <template slot-scope="scope">
              <el-form-item :prop="'calendarPublicHolidayDTOList.' + scope.$index + '.publicHolidayName'">
                <el-input v-model="scope.row.publicHolidayName"
                          :disabled="disabled"
                          maxlength="35"
                          @change="change(scope.$index,scope.row)"
                          placeholder="请输入中文名称"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="publicHolidayEname"
                           label="英文名称"
                           header-align="center"
                           align="center">
            <template slot-scope="scope">
              <el-form-item :prop="'calendarPublicHolidayDTOList.' + scope.$index + '.publicHolidayEname'">
                <el-input v-model="scope.row.publicHolidayEname"
                          @change="change(scope.$index,scope.row)"
                          :disabled="disabled"
                          maxlength="35"
                          placeholder="请输入英文名称"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="startDate"
                           label="开始时间"
                           width="250"
                           header-align="center"
                           align="center">
            <template slot-scope="scope">
              <el-form-item :prop="'calendarPublicHolidayDTOList.' + scope.$index + '.publicHolidayEname'">
                <el-date-picker v-model="scope.row.startDate"
                                @change="change(scope.$index,scope.row)"
                                @blur="clickDay(scope.$index,scope.row)"
                                @focus="getDate(scope.$index,scope.row)"
                                type="date"
                                value-format="yyyy/MM/dd"
                                :picker-options="pickerOptionsStart"
                                :disabled="disabled"
                                placeholder="选择开始日期">
                </el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="endDate"
                           label="结束时间"
                           width="250"
                           header-align="center"
                           align="center">
            <template slot-scope="scope">
              <el-form-item :prop="'calendarPublicHolidayDTOList.' + scope.$index + '.publicHolidayEname'">
                <el-date-picker v-model="scope.row.endDate"
                                @change="change(scope.$index,scope.row)"
                                @blur="clickDay(scope.$index,scope.row)"
                                type="date"
                                value-format="yyyy/MM/dd"
                                :picker-options="pickerOptionsEnd"
                                :disabled="disabled"
                                placeholder="选择结束日期">
                </el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center"
                           width="120"
                           label="操作">
            <template slot-scope="scope">
              <el-button :disabled="delDisable"
                         type="danger"
                         @click="handelDelete(scope.$index,scope.row)">{{ '删除' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>
    <div>
      <el-button type="primary"
                 @click="handleAdd()"
                 v-show="isShow">增加假期</el-button>
    </div>
    <!-- 日历 -->
    <demo ref="demoCalendar"
          v-bind:calendarDTO="editForm.calendarMonthDTOList"
          v-bind:publicHolidayLis="calendarPublicHolidayTableList"
          v-bind:canClick="canClick"
          v-show="flag"></demo>
  </div>
</template>
<script>
import demo from './demo'
import timeUtil from './calendar'
import $ from 'jquery'

export default {
  components: {
    'demo': demo
  },
  data () {
    return {
      flag: false,
      isAdd: false,
      date: new Date(),
      selectDate: '', // 日期选择器选中的月份
      config: {
        firstDay: '0', // 以周日为每周的第一天
        locale: 'zh-cn', // 语言
        defaultView: 'month', // 默认按月显示
        height: 'auto', // 高度
        fixedWeekCount: false, // 是否固定显示六周
        allDaySlot: false,
        header: {// 表头信息
          left: 'prev, next, today',
          center: 'title',
          right: 'month,agendaWeek,agendaDay'
        }
      },
      dataForm: {
        holidayYear: ''
      },
      editForm: {
        calendarPublicHolidayDTOList: [],
        holidayYear: '',
        calendarMonthDTOList: []
      },
      calendarPublicHolidayTableList: [],
      tableList: [],
      year: [],
      dataListLoading: false,
      editShow: true,
      disabled: true,
      isShow: false,
      editable: false,
      delDisable: true,
      canClick: false,
      beforeDeleteData: [],
      startDateVal: '',
      endDateVal: '',
      num: 0,
      rules: {
        // publicHolidayName: [{ required: true, message: '中文名称不能为空', trigger: 'blur' }],
        // publicHolidayEname: [{ required: true, message: '英文名称不能为空', trigger: 'blur' }],
        // startDate: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
        // endDate: [{ required: true, message: '结束不能为空', trigger: 'blur' }],
      },
      newItem: {},
      editItem: {},
      pickerOptionsStart: {
        disabledDate: time => {
          // var myDate = new Date()
          // var date = new Date(myDate.getFullYear(), 0, 1, 0, 0, 0)
          var date = new Date(this.dataForm.holidayYear, 0, 1, 0, 0, 0)
          var date2 = new Date(this.dataForm.holidayYear, 11, 31, 0, 0, 0)
          return time.getTime() < date || time.getTime() > date2
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          // var myDate = new Date()
          // var date = new Date(myDate.getFullYear(), 0, 1, 0, 0, 0)
          var date = new Date(this.dataForm.holidayYear, 0, 1, 0, 0, 0)
          var date2 = new Date(this.dataForm.holidayYear, 11, 31, 0, 0, 0)
          return time.getTime() < date || time.getTime() > date2
        }
      }
    }
  },
  // components: { FullCalendar, addSchedule, eleCalendar, Calendar },
  methods: {
    // 表头加星号样式
    tableHeader (obj) {
      if (obj.columnIndex == 0 || obj.columnIndex == 1 || obj.columnIndex == 2 || obj.columnIndex == 3) {
        return 'tableHeader';
      }
    },

    init () {
      this.getYear()
    },
    getYear () {
      // 获取年
      let date = new Date()
      // console.info('let date -----> ', date)
      let currentYear = date.getFullYear()
      for (let i = 0; i < 4; i++) {
        let y = currentYear + i
        this.year.push(y)
      }
    },
    handleAdd () {
      let row = {
        publicHolidayName: '',
        publicHolidayEname: '',
        startDate: '',
        endDate: '',
        nummm: this.num
      }
      this.num++
      this.editForm.calendarPublicHolidayDTOList.push(row)
      this.calendarPublicHolidayTableList.push(row)
    },
    getDate (index, row) {
      this.startDateVal = row.startDate
      this.endDateVal = row.endDate
    },
    clickDay (index, row) {
      let startDateVal = Date.parse(row.startDate)
      let endDateVal = Date.parse(row.endDate)
      if (startDateVal > endDateVal) {
        this.$message({
          message: '结束日期不能早于开始日期',
          type: 'error',
          duration: 3000
        })
        this.editForm.calendarPublicHolidayDTOList[index].startDate = this.startDateVal
        this.editForm.calendarPublicHolidayDTOList[index].endDate = this.endDateVal
        this.calendarPublicHolidayTableList[index].startDate = this.startDateVal
        this.calendarPublicHolidayTableList[index].endDate = this.endDateVal
      }
    },
    change (index, row) {
      // if (row.publicHolidayEname !== null) {
      //   /* eslint-disable */
      //   row.publicHolidayEname = row.publicHolidayEname.replace(/[^\w]/ig, '')
      // }
      let publicHolidayList = this.calendarPublicHolidayTableList
      for (let i = 0; i < publicHolidayList.length; i++) {
        let timeS = Date.parse(publicHolidayList[i].startDate)
        let timeE = Date.parse(publicHolidayList[i].endDate)
        let rowTimeS = Date.parse(row.startDate)
        let rowTimeE = Date.parse(row.endDate)
        // 日期交集
        if (publicHolidayList[i].id !== row.id || publicHolidayList[i].nummm !== row.nummm) {
          if (!isNaN(rowTimeS) && !isNaN(rowTimeE) && !isNaN(timeS) && !isNaN(timeE)) {
            if (!(timeS > rowTimeE || timeE < rowTimeS)) {
              this.$message({
                message: '时间有冲突，请重新选择',
                type: 'error',
                duration: 3000
              })
              this.calendarPublicHolidayTableList[index].startDate = this.startDateVal
              this.calendarPublicHolidayTableList[index].endDate = this.endDateVal
            }
          }
        } else {
          if (row.createTime !== undefined && row.createTime !== '') {
            row.isChange = 'update'
            let editFormList = this.editForm.calendarPublicHolidayDTOList
            for (let v of editFormList) {
              if (v.id === row.id) {
                v.publicHolidayName = row.publicHolidayName
                v.publicHolidayEname = row.publicHolidayEname
                v.startDate = row.startDate
                v.endDate = row.endDate
                v.isChange = row.isChange
              }
            }
          } else {
            row.isChange = 'insert'
          }
        }
      }
    },
    handelDelete (index, row) {
      if (row.id !== null && row.id !== undefined && row.id !== '' && row.isChange !== 'delete') {
        row.isChange = 'delete'
        row.startDate = this.formartDeleteDate(row.startDate)
        row.endDate = this.formartDeleteDate(row.endDate)
        this.beforeDeleteData.push(Object.assign({}, row)) // 将删除的数据给临时数组
      }
      this.editForm.calendarPublicHolidayDTOList.splice(index, 1) // 删除一行
      this.calendarPublicHolidayTableList.splice(index, 1) // 删除一行
    },
    formartDeleteDate (date) {
      if(date){
        return date.replaceAll("/","-");
      }
    },
    save () {
      let _this = this
      let tableDataList = _this.calendarPublicHolidayTableList
      for (let m = 0; m < tableDataList.length; m++) {
        // if (!tableDataList[m].publicHolidayName || !tableDataList[m].publicHolidayEname || !tableDataList[m].startDate || !tableDataList[m].endDate) {
        //   this.$message({
        //     message: '数据不能有空的',
        //     type: 'error',
        //     duration: 3000
        //   })
        //   return
        // }
        if (!tableDataList[m].publicHolidayName) {
          this.$message({
            message: '中文名称不能为空',
            type: 'error',
            duration: 3000
          })
          return
        } else if (!tableDataList[m].publicHolidayEname) {
          this.$message({
            message: '英文名称不能为空',
            type: 'error',
            duration: 3000
          })
          return
        } else if (!tableDataList[m].startDate) {
          this.$message({
            message: '开始时间不能为空',
            type: 'error',
            duration: 3000
          })
          return
        } else if (!tableDataList[m].endDate) {
          this.$message({
            message: '结束时间不能为空',
            type: 'error',
            duration: 3000
          })
          return
        }
      }
      _this.editForm.holidayYear = _this.dataForm.holidayYear
      // 将要提交的日期格式转为-
      let calendarList = this.editForm.calendarMonthDTOList
      for (let i = 0; i < calendarList.length; i++) {
        for (let j = 0; j < calendarList[i].calendarDTO.length; j++) {
          calendarList[i].calendarDTO[j].calendarDate = timeUtil.dateFormath(calendarList[i].calendarDTO[j].calendarDate)
        }
      }
      _this.editForm.calendarMonthDTOList = calendarList
      let publickcalendarList = this.editForm.calendarPublicHolidayDTOList
      for (let i = 0; i < publickcalendarList.length; i++) {
        publickcalendarList[i].endDate = timeUtil.dateFormath(publickcalendarList[i].endDate)
        publickcalendarList[i].startDate = timeUtil.dateFormath(publickcalendarList[i].startDate)
      }
      _this.editForm.calendarPublicHolidayDTOList = publickcalendarList
      this.$confirm('确定要保存所有公共假期信息么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: function (action, instance) {
          if (action === 'confirm') {
            _this.dataListLoading = true
            _this.isShow = false
            _this.editable = false
            _this.delDisable = true
            _this.disabled = true
            // _this.editForm.calendarPublicHolidayDTOList = _this.calendarPublicHolidayTableList
            if (_this.beforeDeleteData.length > 0) {
              for (var i = 0; i < _this.beforeDeleteData.length; i++) {
                if (_this.editForm.calendarPublicHolidayDTOList.id !== _this.beforeDeleteData[i].id) {
                  _this.editForm.calendarPublicHolidayDTOList.push(_this.beforeDeleteData[i])
                }
              }
            }
            _this.$request.post('/rm/calendarPublicHoliday/save',
              _this.editForm
            ).then((res, total, code, data) => {
              _this.$message({
                message: _this.$t('prompt.success'),
                type: 'success',
                duration: 500
              })
              _this.dataListLoading = false
              _this.getDataList()
              _this.beforeDeleteData = []
            })
              .catch(function (error) {
                console.log(error)
              })
          }
        }
      })
    },
    getDataList () {
      this.dataListLoading = true
      this.$request.get(
        '/rm/calendarPublicHoliday/queryHolidayList',
        {
          order: this.order,
          orderField: this.orderField,
          ...this.dataForm
        }
      ).then((res, total, code, data) => {
        let _this = this
        _this.dataListLoading = false
        let resultList = data.data.calendarPublicHolidayDTOList

        let calendarList = data.data.calendarMonthDTOList
        for (let i = 0; i < calendarList.length; i++) {
          for (let j = 0; j < calendarList[i].calendarDTO.length; j++) {
            calendarList[i].calendarDTO[j].calendarDate = timeUtil.dateFormat(calendarList[i].calendarDTO[j].calendarDate)
          }
        }
        _this.editForm.calendarMonthDTOList = calendarList
        _this.flag = true
        /* eslint-disable */
        _this.$refs.demoCalendar.getList(_this.editForm.calendarMonthDTOList)
        for (let m = 0; m < resultList.length; m++) {
          resultList[m].startDate = timeUtil.dateFormat(resultList[m].startDate)
          resultList[m].endDate = timeUtil.dateFormat(resultList[m].endDate)
        }
        _this.editForm.calendarPublicHolidayDTOList = resultList
        // 过滤指针进行赋值
        _this.calendarPublicHolidayTableList = JSON.parse(JSON.stringify(resultList));
        _this.editShow = true
        _this.isShow = false
        _this.editable = false
        _this.delDisable = true
        _this.disabled = true
        _this.canClick = false
        // 延迟加载
        // _this.$nextTick(() => {
        //   _this.querSelect()
        // })
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    edit () {
      this.isShow = true
      this.editShow = false
      this.editable = true
      this.delDisable = false
      this.disabled = false
      this.canClick = true
    },
    back () {
      this.getDataList()
      this.editShow = true
      this.isShow = false
      this.editable = false
      this.delDisable = true
      this.disabled = true
      this.canClick = false
    },
    selectionChangeHandle () {
      console.log('selectionChangeHandle')
    },
    changeDate () {
      alert(this.selectDate)
      this.$refs.calendar.fireMethod('gotoDate', this.selectDate)
      // this.$refs.calendar.fireMethod('prev')
    },
    eventClick (event) { // events的点击事件
      this.editItem = event
      this.isAdd = true
    },
    dayClick (date, jsEvent, view) { // 日期的点击事件
      this.editItem = {}
      this.isAdd = true
    },
    addItem (detail) {
      this.newItem = JSON.parse(detail)
      if (this.editItem.id) { // 如果是编辑，就删掉该条
        this.events.forEach((el, ind) => {
          if (el.id === this.editItem.id) {
            this.events.splice(ind, 1)
          }
        })
      }
      this.events.push({
        id: this.editItem.id ? this.editItem.id : this.setUuid(),
        title: this.newItem.title,
        start: this.newItem.period[0],
        end: this.newItem.period[1]
      })
    },
    setUuid () {
      var s = []
      var hexDigits = '0123456789abcdef'
      for (var i = 0; i < 36; i++) { s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1) }
      s[14] = '4'
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
      s[8] = s[13] = s[18] = s[23]
      var uuid = s.join('')
      return uuid
    }

  },
  mounted () {
    this.$nextTick(() => {
      console.log('@!@@')
      $('.el-date-editor input').focus()
    })
    this.init()

    var myDate = new Date()
    this.dataForm.holidayYear = myDate.getFullYear()
    this.getDataList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.querybox {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 0px;
  margin-bottom: 5px;
  margin-left: 3px;
  float: right;
  font-size: 14px;
}
.el_calendar .wh_jiantou1 {
  display: none;
}
.el_calendar .wh_jiantou2 {
  display: none;
}
.el_calendar li {
  pointer-events: none;
}
.el_calendar .wh_container {
}
.el-table th.tableHeader div:before {
  content: "*";
  color: #ff1818;
  margin-left: 5px;
}
</style>
<style scoped>
.calendar-div {
  display: flex;
}
.calendar-left {
  width: 300px;
  float: left;
}
.select-right {
  width: 300px;
  float: right;
}
.calendar-right {
  flex: 1;
  float: left;
}
.calendar-div #calendar {
  margin-left: 100px;
  height: 25px;
}
</style>
